export const STORAGE_BUCKET = `https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`;
export const IMG_PLACEHOLDER = "/images/placeholder.png";
export const BKST_LOGO = "/images/logo/logo_200x43.png";

export const TIME_WINDOWS = [
  "8am - 9am",
  "9am - 10am",
  "10am - 11am",
  "11am - Noon",
  "Noon - 1pm",
  "1pm - 2pm",
  "2pm - 3pm",
  "3pm - 4pm",
  "4pm - 5pm",
  "5pm - 6pm",
  "6pm - 7pm",
  "7pm - 8pm",
];

export const REFUND_POLICY =
  "All custom orders are handcrafted, made-to-order and perishable. Each product is hand-made and some design variation should be expected. We ask that you closely inspect your order during pickup or delivery. You are solely responsible for any damage to the items thereafter. Custom cakes and treats are very fragile and damage can happen if not handled properly during transportation & setup. Damage may also happen due to exposure to excessive heat & humidity, which may result in the appearance of cracks, smudges, melted icing/frosting, colors changes and other structural & cosmetic issues. We cannot be held liable for any damage when the items are in your possession. Furthermore, due to the highly subjective nature of taste, we are unable to offer any refund if you find the taste unsatisfactory.";

export const CAKE_SERVINGS = [
  "8-10",
  "12-15",
  "15-20",
  "20-25",
  "25-30",
  "35-40",
  "40-45",
  "55-60",
  "65-70",
  "80-100",
];
export const TREAT_SERVINGS = ["1 dozen", "2 dozen", "3 dozen", "4 dozen", "5 dozen"];

export const STORE_POLICY =
  "<h2>Order Cancellation policy</h2><div>Cancellations made seven (7) or more days prior to the order due date are eligible for a partial refund based on the total amount paid. Customers who have paid fifty percent (50%) or less of the total order amount will not be entitled to any refund. Customers who have paid more than fifty percent (50%) will receive a refund equal to the amount paid in excess of fifty percent (50%) of the total order amount. No refunds will be issued for cancellations made within seven (7) days of the order due date. Refunds may take up to five (5) business days to process.</div><h2>Late Payment Policy</h2><div>If your order is not paid in full by the balance due date, your order will be canceled and there will be no refunds.</div><h2>Fulfillment Policy</h2><div>Orders must be picked up at the scheduled date and time. If we're not informed of a delay, the order will be held only until close of business that day. No refunds or credits will be issued for missed pickups. For deliveries, someone 18 or older must be present to receive the order. If no one is available, the order will be returned to the bakery. A redelivery can be arranged, but a new delivery fee will apply and may be equal to or higher than the original.</div><h2>Returns &amp; Refund policy</h2><div>All custom orders are handcrafted, made-to-order and perishable. Each product is hand-made and some design variation should be expected. We ask that you closely inspect your order during pickup or delivery. You are solely responsible for any damage to the items thereafter. Custom cakes and treats are very fragile and damage can happen if not handled properly during transportation &amp; setup. Damage may also happen due to exposure to excessive heat &amp; humidity, which may result in the appearance of cracks, smudges, melted icing/frosting, colors changes and other structural &amp; cosmetic issues. We cannot be held liable for any damage when the items are in your possession. Furthermore, due to the highly subjective nature of taste, we are unable to offer any refund if you find the taste unsatisfactory.</div>";

export const LABON_XMAS_EXCLUSION_LIST = [
  "HSRws6lt5JTxNVnYSUNb",
  "aGIlIWLcpyiaP02ydj2w",
  "fvgtR3Ak3dfEzDy6U5QM",
  "jQyfNnjBW1coeGf8euoo",
  "Z295AwbnCfx8HbV8I4OE",
  "374UMeQ9HbVv6HcnUcDU",
  "6XZPCn9JpZRmty22I6Dq",
  "7fiMDTOF4mp24QYWSXG3",
  "IIRZLekG9f6SrLZ76hCa",
  "aUcjugfccPbXnNo4yCgw",
  "NWXD9YK1m4pSyKRKNEX3",
  "x5UZaTPizIu0rhoBvQj5",
  "f8cf49HSrNuVjdPokH9U",
  "BO8gnDAyq2laR8LKgJbl",
  "Y9fc1sw7NfLAeqDuV0fx",
  "eBSPt82r5X57LnufTodR",
  "fwVJcM9QSTfjxpx5HDKH",
  "hmZLlE0GMP7gvwaCN5X6",
  "aT41LvpHm62DYDy0PUvH",
  "mMpcX3eQPDIfVHuYNv40",
  "KKrKnTSadGPSAu3GiM9A",
  "Yh0e3Xw7yNpZRSedpPv5",
  "2BETaK4x8BByxBeNpHNA",
  "M7Ro4ZGi51x6EiZ1E7kX",
  "sJYHLX7dt5vKjQeZXYh4",
  "ZBZyqvOzaZyI8Xd8DHdZ",
  "KlgTKSh3TGPEoLgxA2Nw",
  "S4yZnD1xPH5o3ezgtkxb",
  "T15antSI00wFdkDUgVhV",
  "5Si7Ouq8y939s8iliqCH",
  "R5IHBQlHwP21lxnv8tCs",
  "ULoDU9xfAePbKZaeyRWT",
  "FnRe2bZAiqQBlCmiFhSx",
  "PER4KxNL0Z43UB6isEpG",
  "xffy1KI3AL3hNvFhh8ON",
  "JbK0SPl7bixuIRpB4pHl",
  "Ex4BbkVkPK0ztJqLybVO",
  "8dNOWf0mLBk7pVM5Z3x0",
  "JtJ1Lp3KqyiPzhI6JZH9",
  "q4iKqZQjxzAZiZ4ISqla",
  "wPk6PMsBBRdD33SQVMXN",
  "D5FsnEdyGKRSn1vuT4ZI",
  "jkeuADTlsG7thqN2hQlJ",
  "oRDV2AnKxJuzLeAOJGKC",
  "s4l7ePWfP3TOTvJWM6ma",
];

export const LABON_THANKSGIVING_EXCLUSION_LIST = [
  "1RBkosq4MYCsg6gpgWhb",
  "HSRws6lt5JTxNVnYSUNb",
  "aGIlIWLcpyiaP02ydj2w",
  "fvgtR3Ak3dfEzDy6U5QM",
  "jQyfNnjBW1coeGf8euoo",
  "Z295AwbnCfx8HbV8I4OE",
  "KKrKnTSadGPSAu3GiM9A",
  "Yh0e3Xw7yNpZRSedpPv5",
  "2BETaK4x8BByxBeNpHNA",
  "M7Ro4ZGi51x6EiZ1E7kX",
  "sJYHLX7dt5vKjQeZXYh4",
  "ZBZyqvOzaZyI8Xd8DHdZ",
  "eBSPt82r5X57LnufTodR",
  "S4yZnD1xPH5o3ezgtkxb",
  "ZBZyqvOzaZyI8Xd8DHdZ",
  "JtJ1Lp3KqyiPzhI6JZH9",
  "q4iKqZQjxzAZiZ4ISqla",
  "OBvvof4rVEMjZKuJUzuG",
  "D5FsnEdyGKRSn1vuT4ZI",
  "jkeuADTlsG7thqN2hQlJ",
  "xffy1KI3AL3hNvFhh8ON",
  "ULoDU9xfAePbKZaeyRWT",
  "R5IHBQlHwP21lxnv8tCs",
  "yQ3mvGnzinDaWjahMkKP",
  "WDzKBLDwZVy8UdfJg0VW",
  "JbK0SPl7bixuIRpB4pHl",
  "8j2uWt888Q4o0oVubRTJ",
  "PER4KxNL0Z43UB6isEpG",
  "Ex4BbkVkPK0ztJqLybVO",
  "6XZPCn9JpZRmty22I6Dq",
  "7fiMDTOF4mp24QYWSXG3",
  "aUcjugfccPbXnNo4yCgw",
  "NWXD9YK1m4pSyKRKNEX3",
  "x5UZaTPizIu0rhoBvQj5",
  "f8cf49HSrNuVjdPokH9U",
  "BO8gnDAyq2laR8LKgJbl",
  "mMpcX3eQPDIfVHuYNv40",
  "Y9fc1sw7NfLAeqDuV0fx",
  "fwVJcM9QSTfjxpx5HDKH",
  "hmZLlE0GMP7gvwaCN5X6",
  "aT41LvpHm62DYDy0PUvH",
  "oRDV2AnKxJuzLeAOJGKC",
  "aKkQdhg6uyEtryLw91Rv",
  "374UMeQ9HbVv6HcnUcDU",
  "8dNOWf0mLBk7pVM5Z3x0",
  "wPk6PMsBBRdD33SQVMXN",
  "T15antSI00wFdkDUgVhV",
  "5Si7Ouq8y939s8iliqCH",
  "s4l7ePWfP3TOTvJWM6ma",
  "FnRe2bZAiqQBlCmiFhSx",
  "72E7a27RUdtge69yOnJw",
  "KlgTKSh3TGPEoLgxA2Nw",
];

export const LABON_EASTER_EXCLUSION_LIST = [
  "HSRws6lt5JTxNVnYSUNb",
  "aGIlIWLcpyiaP02ydj2w",
  "fvgtR3Ak3dfEzDy6U5QM",
  "jQyfNnjBW1coeGf8euoo",
  "Z295AwbnCfx8HbV8I4OE",
  "374UMeQ9HbVv6HcnUcDU",
  "6XZPCn9JpZRmty22I6Dq",
  "7fiMDTOF4mp24QYWSXG3",
  "IIRZLekG9f6SrLZ76hCa",
  "aUcjugfccPbXnNo4yCgw",
  "NWXD9YK1m4pSyKRKNEX3",
  "x5UZaTPizIu0rhoBvQj5",
  "f8cf49HSrNuVjdPokH9U",
  "BO8gnDAyq2laR8LKgJbl",
  "Y9fc1sw7NfLAeqDuV0fx",
  "eBSPt82r5X57LnufTodR",
  "fwVJcM9QSTfjxpx5HDKH",
  "hmZLlE0GMP7gvwaCN5X6",
  "aT41LvpHm62DYDy0PUvH",
  "mMpcX3eQPDIfVHuYNv40",
  "KKrKnTSadGPSAu3GiM9A",
  "Yh0e3Xw7yNpZRSedpPv5",
  "2BETaK4x8BByxBeNpHNA",
  "M7Ro4ZGi51x6EiZ1E7kX",
  "sJYHLX7dt5vKjQeZXYh4",
  "ZBZyqvOzaZyI8Xd8DHdZ",
  "KlgTKSh3TGPEoLgxA2Nw",
  "S4yZnD1xPH5o3ezgtkxb",
  "T15antSI00wFdkDUgVhV",
  "5Si7Ouq8y939s8iliqCH",
  "s4l7ePWfP3TOTvJWM6ma",
  "R5IHBQlHwP21lxnv8tCs",
  "ULoDU9xfAePbKZaeyRWT",
  "FnRe2bZAiqQBlCmiFhSx",
  "PER4KxNL0Z43UB6isEpG",
  "xffy1KI3AL3hNvFhh8ON",
  "JbK0SPl7bixuIRpB4pHl",
  "Ex4BbkVkPK0ztJqLybVO",
  "8dNOWf0mLBk7pVM5Z3x0",
  "JtJ1Lp3KqyiPzhI6JZH9",
  "q4iKqZQjxzAZiZ4ISqla",
  "wPk6PMsBBRdD33SQVMXN",
  "D5FsnEdyGKRSn1vuT4ZI",
  "jkeuADTlsG7thqN2hQlJ",
  "oRDV2AnKxJuzLeAOJGKC",
  "V70ktoud01Jb1VHKtL0A",
  "C4E29jjpMtDV9lkxPzvl",
  "1sAHaWoQc1Dm4ooDqxTf",
  "l2M7TYHLGZIeGkG6zH5g",
  "Md13VHkEXxQgWqbgipsb",
  "ESjnhcmkgNF1G5i6m4A5",
  "3u4XRe6oZW3xqXgt4ZzR",
];
